import type {RichtextStoryblok, RichTextEditorStoryblok} from '@/storyblok/types';

export type RichtextInput = RichtextStoryblok | RichTextEditorStoryblok | null | undefined;

export function isRichTextEditor(richtext: RichtextStoryblok | RichTextEditorStoryblok): richtext is RichTextEditorStoryblok {
	return 'component' in richtext && richtext.component === 'RichTextEditor';
}

function getBlocks(richtext: RichtextInput): RichtextStoryblok[] | undefined {
	if (!richtext) {
		return undefined;
	}

	return isRichTextEditor(richtext) ? richtext.content?.content : richtext.content;
}

export function richtextIsEmpty(richtext: RichtextInput) {
	const firstBlock = getBlocks(richtext)?.[0];
	return !(firstBlock?.content && firstBlock.content.length > 0);
}
